import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/app/[course]/my-tee-box/page.tsx");
